import axios from '@/plugins/axios'

export default {
  generateDocument(data) {
    return axios.post('documents/generate-document', data).then(response => {
      return response.data
    })
  },
  createPreview(data) {
    return axios.post('documents/create-preview', data).then(response => {
      return response.data
    })
  },
  submitToGetAccept(id) {
    return axios.get(`documents/${id}/get-accept/send`).then(response => {
      return response.data
    })
  },
  getCategories() {
    return axios.get('documents/categories').then(response => response.data)
  },
  getLogisticsCategories() {
    return axios.get('documents/logistics-categories').then(response => response.data)
  },
  delete(id) {
    return axios.delete(`documents/${id}`).then(response => response.data)
  },
  changeCategory(ids, newCategory) {
    return axios.post(`documents/change-category`, {
      document_ids: ids,
      new_category: newCategory
    }).then(response => response.data)
  },
  toggleOwnerVisibility(documentId) {
    return axios.get(`documents/${documentId}/toggle-owner-visibility`).then(response => response.data)
  }
}
